
import angular from 'angular'

import { postsRoutes } from './posts.routes'

import { postsService } from './services/posts.service'

import { postDetails } from './directives/post-details/post-details.directive'
import { postSlider } from './directives/post-slider/post-slider.directive'
import { postCore } from './directives/post-core/post-core.directive'
import { readersCore } from './directives/readers-core/readers-core.directive'
import { readersSlider } from './directives/readers-slider/readers-slider.directive'
import { attachmentLogsSlider } from './directives/attachment-logs-slider/attachment-logs-slider.directive'
import { attachmentLogsCore } from './directives/attachment-logs-core/attachment-logs-core.directive'
import { reactionBar } from './directives/reaction-bar/reaction-bar.directive'

import { postItem } from './components/post-item/post-item.component'
import { categoryFilterParentItem } from './components/category-filter-parent-item/category-filter-parent-item.component'

const module = angular
  .module('deskfy.posts', [])
  .config(postsRoutes)
  .factory('PostsService', postsService)
  .directive('postDetails', postDetails)
  .directive('postSlider', postSlider)
  .directive('postCore', postCore)
  .directive('readersCore', readersCore)
  .directive('readersSlider', readersSlider)
  .directive('attachmentLogsSlider', attachmentLogsSlider)
  .directive('attachmentLogsCore', attachmentLogsCore)
  .directive('reactionBar', reactionBar)
  .component('postItem', postItem)
  .component('categoryFilterParentItem', categoryFilterParentItem)

export const postsModule = module
